import { z } from "zod";
// The staff attention summary (CHT-767, Phase 13.1): `GET /staff/attention`, in `apps/api/src/routes/staff-attention-routes.ts`. The admin
// calls it only through `@lafayette/api-client` (`staff-attention.ts`).
//
// STAFF ONLY and closed: a source key, an area, a severity and an item kind come from the lists below (parity-tested against the
// application's tuples in `apps/api/src/routes/staff-attention-routes.test.ts`). The shapes are strict, so a field that is not listed fails
// the parse (500) and nothing leaks. An item holds ids, a closed code, the customer display name the inbox already shows to the same
// staff member, and a time. It holds no message text, no note and no evidence.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/u;
const uuid = z.string().regex(UUID);
const instant = z.iso.datetime({ offset: false });
export const staffAttentionSourceKeyValues = [
    "handoffs_waiting",
    "handoffs_at_risk",
    "coverage_exceptions",
    "conversations_customer_replied",
    "conversations_need_staff",
    "requests_unassigned",
    "requests_aging",
    "requests_customer_answered",
    "requests_assigned_to_me",
    "payments_to_reconcile",
];
export const staffAttentionAreaValues = [
    "conversations",
    "requests",
    "trips",
    "customers",
    "catalog",
    "imports",
    "payments",
    "operations",
];
export const staffAttentionSeverityValues = ["urgent", "attention", "info"];
export const staffAttentionItemKindValues = ["conversation", "request"];
export const staffAttentionItemSchema = z.strictObject({
    kind: z.enum(staffAttentionItemKindValues),
    id: uuid,
    customer: z.strictObject({ id: uuid, displayName: z.string().min(1).max(200) }),
    code: z.string().min(1).max(64).nullable(),
    since: instant.nullable(),
});
export const staffAttentionSourceSchema = z.strictObject({
    key: z.enum(staffAttentionSourceKeyValues),
    area: z.enum(staffAttentionAreaValues),
    severity: z.enum(staffAttentionSeverityValues),
    /** `unavailable`: the source could not be read. The count is 0 and no item is listed; the screen must say it is blind there. */
    status: z.enum(["ok", "unavailable"]),
    count: z.number().int().min(0).max(1000),
    /** `true`: there are more than `count`. */
    capped: z.boolean(),
    items: z.array(staffAttentionItemSchema).max(10),
});
export const staffAttentionSummarySchema = z.strictObject({
    generatedAt: instant,
    features: z.strictObject({ payments: z.boolean() }),
    sources: z.array(staffAttentionSourceSchema).max(64),
});
